import ageGate from './ageGate'
import ageGateTextOverride from './ageGateTextOverride'
import auth from './auth'
import banner from './banner'
import bannerTextOverride from './bannerTextOverride'
import bannerUrl from './bannerUrl'
import consent from './consent'
import cookie from './cookie'

const cookies = {
  ageGate,
  ageGateTextOverride,
  auth,
  banner,
  bannerTextOverride,
  bannerUrl,
  consent,
  cookie,
}

export default cookies
